<script lang="ts">
  import { Circle } from "svelte-loading-spinners";
  import { validateCrypto, validateExchangeRate } from "../jobs";

  import Button from "./Button.svelte";
  import Feedback from "./Feedback.svelte";

  export let currency: string | null | undefined;
  export let address: string | undefined;
  export let symbol: "BTC" | "ETH" | undefined;
  export let isValid: boolean | undefined = undefined;

  let isLoading: boolean = false;

  async function handleClick() {
    if (!address || !symbol) {
      return;
    }

    isLoading = true;
    if (
      (await validateCrypto({
        address,
        type: symbol,
      })) &&
      currency &&
      (await validateExchangeRate(currency, symbol))
    ) {
      isValid = true;
    } else {
      isValid = false;
    }
    isLoading = false;
  }

  $: {
    if (address || symbol) {
      isValid = undefined;
    }
  }
</script>

<style>
  .root {
    width: 400px;
  }
</style>

<div class="root">
  <label for="price" class="block text-sm font-medium text-gray-700">Public
    Address</label>
  <div class="flex flex-row mt-1 items-center">
    <div class="mr-2 relative rounded-md shadow-sm">
      <div
        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <span class="text-gray-500 sm:text-sm"> # </span>
      </div>
      <input
        type="text"
        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
        class:border-red-500={isValid === false}
        placeholder="0x00"
        bind:value={address} />
      <div class="absolute inset-y-0 right-0 flex items-center">
        <label for="currency" class="sr-only">Currency</label>
        <select
          bind:value={symbol}
          class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md">
          <option>BTC</option>
          <option>ETH</option>
        </select>
      </div>
    </div>
    {#if isLoading}
      <Circle size="24" color="#3b83f6" unit="px" duration="1s" class="mr-2" />
    {:else}
      <Button on:click={handleClick}>Select</Button>
    {/if}
  </div>
  {#if isValid === false}
    <div class="mt-2 text-red-500 text-base">
      Unfortunatelly we do not either support the address or the conversion of
      the crypto to your budgets currency. Sorry for that, leave a feedback
      please!
      <Feedback />
    </div>
  {/if}
</div>
